<template>
  <div v-if="shouldDisplay" class="all-listing-filters">
    <div class="adv-listing-filters-clear">
      <a :href="getUrlNoFilters" class="adv-listing-filters-clear-btn">{{ t('filters.clear.all') }}</a>
      <img src="/ui/main/img/filter_icon_purple.png" alt="">

    </div>
    <h6 @click="toggleCollapse" class="all-listing-filters-title">
      <span class="all-listing-filters-title-text">
        {{ t('filters.title') }}
      </span>
      <button class="all-listing-filters-title-btn">
        <em :class="['ti-close', { 'ti-angle-down': !collapsed, 'ti-angle-up': collapsed }]"></em>
      </button>
    </h6>
    <transition name="collapse-fade">
      <div v-if="!collapsed" :class="['all-listing-filters-slot', { 'collapsed': collapsed }]">
        <tag-listing-filters></tag-listing-filters>
        <variation-listing-filters></variation-listing-filters>
        <attribute-listing-filters></attribute-listing-filters>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TagListingFilters from './tag/filters/Components/TagListingFilters.vue'
import VariationListingFilters from './variations/filters/Components/VariationListingFilters.vue'
import AttributeListingFilters from './attributes/filters/Components/AttributeListingFilters.vue'

export default {
  name: 'AllListingFilters',
  components: {
    TagListingFilters,
    VariationListingFilters,
    AttributeListingFilters
  },
  data () {
    return {
      collapsed: false
    }
  },
  computed: {
    ...mapGetters([
      'getVariationsActive',
      'getListingVariationGroupCombos',
      'getAttributesActive',
      'getListingAttributeGroupCombos',
      'getListingTagGroupCombos',
      'getUriWithoutOffset',
      'getIsTopLevelCategory',
      'getUrlNoFilters',
      'config'
    ]),
    shouldDisplay () {
      return this.shouldDisplayTags || this.shouldDisplayAttributes || this.shouldDisplayVariations
    },
    shouldDisplayTags () {
      return this.getListingTagGroupCombos.length > 0
    },
    shouldDisplayAttributes () {
      return this.getAttributesActive && this.getListingAttributeGroupCombos.length > 0
    },
    shouldDisplayVariations () {
      return this.getVariationsActive && this.getListingVariationGroupCombos.length > 0
    }
  },
  methods: {
    toggleCollapse () {
      this.collapsed = !this.collapsed
    }
  }
}
</script>

<style lang="scss" scoped>
.all-listing-filters {
  top: 5px;
  position: relative;
  width: 100%;
  border-radius: 0;
  box-shadow: none;
  margin-bottom: 30px;
  padding-right: 15px;
  padding-left: 15px;
  padding-bottom: 10px;
  background-color: #fff;
  &-slot {
    position: relative;
    display: grid;
  }
  &-title {
    cursor: pointer;
    font-size: 24px;
    font-weight: 900;
    margin: 0 0 15px 0;
    display: block;
    width: 100%;
    padding: 15px 0;
    border-bottom: 2px solid black;
    position: relative;
    &-text {

    }
    &-btn {
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
      width: 24px;
      height: 24px;
      text-align: center;
      background: unset;
      border: unset;
    }
  }
}
.ti-close {
  font-size: 14px;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 auto;
}
.collapse-fade-enter-active, .collapse-fade-leave-active {
  transition: opacity 0.5s;
}
.collapse-fade-enter, .collapse-fade-leave-to {
  opacity: 0;
}
</style>
